import { OutlinedInput } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo, useRef } from 'react';
import { useChangeTracker } from '../../context/change-tracker';
import { fields } from './mockData';
import * as Styled from './styles';
import * as SX from './sx';
import type { CompanyTabProps as Props } from './types';

export const CompanyTab = memo(({ className }: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { markDirty } = useChangeTracker();

  const handleOpenFile = () => fileInputRef.current?.click();

  const handleFileSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    markDirty();
  };

  return (
    <Styled.Wrapper className={classnames('ClientTab', className)} sx={SX.root}>
      {fields.map(({ key, label, readOnly, ...rest }) => {
        const isLogo = key === 'companyLogo';

        return (
          <Stack key={key} gap={0.5}>
            <Typography variant="body4" color="grey.500" fontWeight={400}>
              {label}
            </Typography>

            <OutlinedInput
              size="medium"
              {...rest}
              inputProps={readOnly ? { readOnly: true } : undefined}
              endIcon={isLogo ? 'add-image' : undefined}
              onClickEndIcon={isLogo ? handleOpenFile : undefined}
              onChange={markDirty}
            />

            {isLogo && (
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileSelected}
              />
            )}
          </Stack>
        );
      })}
      <Stack direction="row" gap={1}>
        <Stack gap={0.5}>
          <Typography variant="body4" color="grey.500" fontWeight={400}>
            State
          </Typography>
          <OutlinedInput
            defaultValue="New York"
            placeholder="No state added."
            size="medium"
            onChange={markDirty}
          />
        </Stack>
        <Stack gap={0.5}>
          <Typography variant="body4" color="grey.500" fontWeight={400}>
            City
          </Typography>
          <OutlinedInput
            defaultValue="New York"
            placeholder="No city added."
            size="medium"
            onChange={markDirty}
          />
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

CompanyTab.displayName = 'CompanyTab';
